import Styles from './GridViewCard.module.scss';
import React, { useContext, useEffect, useState } from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";

// Module imports.
import axios from 'axios';
import FeatherIcon from 'feather-icons-react';
import { Chip, Stack, Tooltip, LinearProgress } from '@mui/material';
import { lightBlue } from '@mui/material/colors';

// Components import.
import { ViewContext, useNavigate } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { MilitaryTech } from '@mui/icons-material';

/**
 * 
 * @param {boolean} minimal if true then shows a shrunk version of the card
 * @returns 
 */
const GridViewCard = ({ tooltipMessage, data, minimal = false, ...props }) => {
	const [isLoadingOpen, setIsLoadingOpen] = useState(false);
	const [certNames, setCertNames] = useState([])
	const navigate = useNavigate()
	const [orderId, setOrderId] = useState(0)

	const viewContext = useContext(ViewContext)

	const labsCerts = (labID) => {
		const postData = {
			labId: labID,
		};

		const url = '/api/labs/learning_path/all';

		axios.post(url, postData)
			.then(function (response) {
				setCertNames(response.data)
			})
			.catch(function (error) {
				console.error('POST request failed', error);
			});
	}

	useEffect(() => {
		if (orderId) {
			props.getOrder(orderId)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderId])

	//converting the due date into dd-mm-yyy format
	var date = data?.due_date && new Date(data?.due_date);
	var dueDate = data?.due_date && date.toLocaleDateString(
		'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }
	);
	const pDate = data?.purchase_date && new Date(data?.purchase_date);
	const purchaseDate = data?.purchase_date && pDate.toLocaleDateString(
		'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }
	);
	return (
		<>
			<LoadingBackdrop isOpen={isLoadingOpen} />
			<div id='gridAncestor' className={Styles.container}
				data-tooltip-id={data?.hasOwnProperty("cert_id") && "purchase_labs"}
				data-tooltip-content={JSON.stringify(certNames)}
				onClick={() => {
					setOrderId(data.order_id ? data.order_id : 0)
					if (props.button_text === "In Certifications") {
						return labsCerts(data?.id)
					}

					if (data.isDisabled) {

						return props?.expiredRedirection && navigate(props?.expiredRedirection)
					} else {
						setIsLoadingOpen(true);
						props.onClick(data);
						setIsLoadingOpen(true);
					}
				}}
			>
				<div className={Styles.childContainer}
					style={{
						cursor: 'pointer',
						backgroundColor: data?.isDisabled ? '#e8e9eb' : '#fff'
					}}
				>
					<p className={Styles.headerText}>
						{data.name}
						{data?.due_date &&
							<span title={viewContext.t('Components.GridViewCard.dueDate')} className={Styles.dueDate}>
								<FeatherIcon icon="clock" size='12px'
									style={{
										color: 'grey',
										marginRight: '4px'
									}}
								/>
								{purchaseDate && dueDate ? `${purchaseDate} - ${dueDate}` : dueDate}
							</span>}

					</p>
					{/* image part */}
					<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}${data.icon}`} alt="courseImage" className={Styles.courseImage} />
					{/* content part */}
					<div id='contentContainer' className={Styles.contentContainer}>

						<div id='infoContainer'>
							{!minimal &&
								<div id='descrContainer' className={Styles.descrContainer}>
									<p className={Styles.descriptionText}>{data.descr}</p>
								</div>
							}
							<div id='streamData' style={{
								display: "flex",
								height: props.showInfoChips || props.showLevelChip ? "50px" : "0px",
								flexDirection: "column"
							}}>
								<Stack
									direction="row"
									spacing={1}
									sx={{
										marginTop: '8px',
										marginBottom: '4px',
										height: '30px'
									}}
								>
									<Chip
										// label={`Score: ${data.score} / ${data.totalScore !== undefined ? data.totalScore : 10}`}
										label={viewContext.t('Components.GridViewCard.score', { score: data.score, total: data.totalScore !== undefined ? data.totalScore : 10 })}
										size="medium"
										sx={{
											width: props.showInfoChips && !props.showMedalChips ? '100%' : '60%',
											fontWeight: 550,
											bgcolor: "#1de9b6",
											display: props.showInfoChips ? "" : 'none'
										}}
									/>
									<Chip
										label={data.level}
										size="medium"
										sx={{
											bgcolor: lightBlue[300],
											fontWeight: 550,
											width: '40%',
											display: props.showLevelChip ? "" : 'none'
										}}
									/>

									<div id='medalContainer' className={Styles.medalContainer}
										style={{
											display: props.showMedalChips ? "" : 'none'
										}}>
										{/* gold = 3, silver = 2, bronze = 1 */}
										<MilitaryTech fontSize='large' sx={{ color: '#F7C706', opacity: data.badge === 3 ? 1 : 0.3 }} />
										<MilitaryTech fontSize='large' sx={{ color: '#8D9297', opacity: data.badge === 2 ? 1 : 0.3 }} />
										<MilitaryTech fontSize='large' sx={{ color: '#CE8946', opacity: data.badge === 1 ? 1 : 0.3 }} />

									</div>
								</Stack>
								{props.showProgressBar ? (
									<Tooltip title={tooltipMessage} arrow placement='right'>
										<div style={{
											display: "flex",
											alignItems: "center",
											gap: "4px",
											width: "100%",
											alignSelf: "flex-end",
											marginTop: '4px',

										}}>
											<LinearProgress
												variant="determinate"
												value={data.completion_percentage}
												className={Styles.progessBar}
												sx={{
													backgroundColor: (data.status !== "in_progress" && data.status !== "completed") ? "grey" : "#6382702e",
													"& .MuiLinearProgress-bar": {
														backgroundColor: "#008037",
													},
												}}
											/>

											<p styles={{ fontSize: "12px" }}>{data.completion_percentage}%</p>
										</div>
									</Tooltip>
								) : null}
							</div>
						</div>
					</div>
					{/* submit button part */}
					<div className={Styles.buttonContainer}>
						<button
							className={Styles.startButton}
							// onClick={() => props.onClick(data.id)}
							style={{
								backgroundColor: (props.button_text === 'In Certifications') ? '#008037' : data.isFailed ? '#FF1616' : '$c-aivagam-blue',
								pointerEvents: data.isDisabled && "none"
							}}
							variant="contained"
							disabled={data.isDisabled}
							color={(data.isDisabled) ? 'gray' : 'blue'}
						>
							{viewContext.t(`Components.GridViewCard.button.${props.button_text}`)}
						</button>

					</div>
				</div>
			</div>
			<ReactTooltip
				closeOnScroll id="purchase_labs"
				clickable
				events={['click']}
				className={Styles.toolTip} place='right'
				style={{
					backgroundColor: "#fff",
					color: "#222",
					boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px'
				}}
				render={({ content, activeAnchor }) => (
					<div className={Styles.tooltipMain}>
						<p className={Styles.frmCert}>{viewContext.t('Components.GridViewCard.prompt')}</p>
						{
							JSON.parse(content)?.data?.map((cert, index) => {
								return (
									<div key={index}>
										<p
											className={Styles.certName}
											onClick={() => {
												props.onClick(cert.id)
											}}
											style={{ textDecoration: cert?.isExpired && 'line-through' }}
										>
											{index + 1}. {cert.name}
										</p>
									</div>
								);
							})
						}
					</div>

				)} />
		</>
	);
};

export default GridViewCard;
